/*
 * Тексты страницы входа и согласия ИИ-агента (005, T029; research R15; FR-005, FR-060, FR-063). Язык — ASD-STE100:
 * короткие предложения, условие первым, одно слово — одно значение, без латиницы. Проверяет `texts.test.tsx`
 * (`@tabel/shared/plain-language`). Имя клиента, хосты, права токена и их тексты приходят с сервера — здесь их нет.
 * Ошибки входа — те же, что на странице входа табеля (`pages/Login`).
 */

/** Заголовки экранов — до 4 слов. */
export const TITLE = {
  login: 'Вход',
  consent: 'Подключение ИИ-агента',
  refused: 'Подключение невозможно',
  expired: 'Время входа истекло',
  loadError: 'Страница не загрузилась',
} as const;

/** Подписи полей, кнопок и строк — до 6 слов. */
export const LABEL = {
  brand: 'Табель',
  login: 'Логин',
  password: 'Пароль',
  enter: 'Войти',
  entering: 'Вход…',
  client: 'Клиент агента',
  clientDoc: 'Документ клиента',
  redirect: 'Адрес возврата',
  account: 'Учётная запись',
  thisComputer: 'Этот компьютер',
  scopes: 'Что сможет агент',
  allow: 'Разрешить',
  deny: 'Отказать',
  sending: 'Отправка…',
  retry: 'Повторить',
  loading: 'Загрузка…',
  errorCode: 'Код ошибки:',
} as const;

/** Предложения страницы. */
export const T = {
  loginIntro: 'Войдите в табель, чтобы подключить ИИ-агента.',
  accountNote: 'Учётную запись выдаёт администратор системы.',
  consentIntro: 'ИИ-агент просит доступ к табелю от вашего имени. Агент получит только права из списка.',
  localhost:
    'Ответ получит программа на этом компьютере. Если вход в ИИ-агенте начали не вы, нажмите «Отказать».',
  /** Текст FR-063. Название права — в «ёлочках», как на всех страницах 005 (в FR-063 оно во вложенных кавычках). */
  rightMissing: 'Подключать ИИ-агента может только пользователь с правом «ИИ-агент».',
  rightMissingFix: 'Право выдаёт администратор системы.',
  noRole: 'У вас нет роли, с которой можно подключить ИИ-агента.',
  noRoleFix: 'Роль назначает администратор системы.',
  noScopes: 'Агенту нельзя выдать ни одного права.',
  refuseNote: 'Нажмите «Отказать», и ИИ-агент получит отказ.',
  expired: 'Начните подключение в ИИ-агенте заново.',
  badCredentials: 'Неверный логин или пароль',
} as const;

/** Тексты с подстановкой. */
export const say = {
  /** `LOGIN_LOCKED`: через сколько минут повторить, как на странице входа табеля (без срока — 15 мин). */
  locked: (retryAfterSec: number | undefined) =>
    `Слишком много попыток. Попробуйте через ${Math.max(1, Math.ceil((retryAfterSec ?? 900) / 60))} мин.`,
};
